var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttachmentNext(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconAttachmentNext_svg__clip0_5652_7643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.523.274s.111.084.15.12c2.765 2.696 8.444 8.255 8.444 8.29-.075.057-4.594 4.433-6.78 6.564L2.504 17.03c-.575-.574-1.137-1.144-1.7-1.714v-.054c.04-.03 4.52-4.38 6.717-6.522.036-.035.068-.077.103-.12l-.119-.126C5.32 6.368 3.133 4.238.947 2.107a1.016 1.016 0 01-.142-.161L2.523.274z",
    fill: "#879494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconAttachmentNext_svg__clip0_5652_7643"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 8.918 8.113)",
    d: "M0 0h16.758v10.312H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachmentNext);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconAttachmentNext.2463d529.svg";
export { MemoForwardRef as ReactComponent };